import { FC } from 'react';

import { Icon } from './Icon';
import { SvgIcon } from './SvgIcon.type';

export const IconCalendar: FC<SvgIcon> = (props) => (
  <Icon {...props} viewBox="0 0 24 24" name="calendar">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 14.9999C12 16.6568 10.6569 17.9999 9 17.9999C7.34315 17.9999 6 16.6568 6 14.9999C6 13.3431 7.34315 11.9999 9 11.9999C10.6569 11.9999 12 13.3431 12 14.9999ZM10.8 14.9999C10.8 15.994 9.99411 16.7999 9 16.7999C8.00589 16.7999 7.2 15.994 7.2 14.9999C7.2 14.0058 8.00589 13.1999 9 13.1999C9.99411 13.1999 10.8 14.0058 10.8 14.9999Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.5999 2.3999V3.99991H15.3999V2.3999H16.5999V3.99991H19C20.1046 3.99991 21 4.89534 21 5.99991V18.9999C21 20.1045 20.1046 20.9999 19 20.9999H5C3.89543 20.9999 3 20.1045 3 18.9999V5.99991C3 4.89534 3.89543 3.99991 5 3.99991H7.3999V2.3999H8.5999ZM15.3999 5.19991V7.5999H16.5999V5.19991H19C19.4418 5.19991 19.8 5.55808 19.8 5.99991V9.3999H4.2V5.99991C4.2 5.55808 4.55817 5.19991 5 5.19991H7.3999V7.5999H8.5999V5.19991H15.3999ZM4.2 10.5999H19.8V18.9999C19.8 19.4417 19.4418 19.7999 19 19.7999H5C4.55817 19.7999 4.2 19.4417 4.2 18.9999V10.5999Z"
    />
  </Icon>
);
